if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            // console.log('Product recommendations loaded responseText', responseText);
            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
              // initialize swipers inside the loaded recommendations
              this.initSwipers();
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }


      /**
       * Initialize simple swipers for any .swipe-mobile containers inside the recommendations
       */
      initSwipers() {
        if (!window.FoxTheme || !window.FoxTheme.Carousel) {
          console.warn('product-recommendations: FoxTheme.Carousel not available');
          return;
        }

        const swipeContainers = this.querySelectorAll('.enable-slider');
        swipeContainers.forEach((container, idx) => {
          try {
            // inner wrapper that contains product columns
            const inner =
              container.querySelector('.swipe-mobile__inner') ||
              container.querySelector('.products-list') ||
              container;

            if (!inner) return;

            // Ensure DOM structure matches Swiper expectations
            // outer container should have 'swiper' class; inner should be 'swiper-wrapper'
            container.classList.add('swiper');
            inner.classList.add('swiper-wrapper');

            // Make each direct child a slide
            Array.from(inner.children).forEach((child) => {
              child.classList.add('swiper-slide');
            });

            // parse columns from class name e.g. swipe-mobile--2-cols
            let slidesPerView = 1;
            const match = Array.from(container.classList).join(' ').match(/swipe-mobile--(\d+)-cols/);
            if (match && match[1]) {
              slidesPerView = Math.max(1, parseInt(match[1], 10));
            }

            const spaceBetween = 12;

            // navigation buttons scoped to this container
            const nextBtn = container.querySelector('.product-tabs-btn-next') || container.querySelector('.swiper-button-next');
            const prevBtn = container.querySelector('.product-tabs-btn-prev') || container.querySelector('.swiper-button-prev');

            const options = {
              init: false,
              slidesPerView: 1.3,
              spaceBetween: spaceBetween,
              loop: false,
              freeMode: true,
              watchOverflow: true,
              grabCursor: true,
              threshold: 5,
              breakpoints: {
                768: {
                  slidesPerView: 4,
                }
              },
            };

            if (nextBtn || prevBtn) {
              options.navigation = {};
              if (nextBtn) options.navigation.nextEl = nextBtn;
              if (prevBtn) options.navigation.prevEl = prevBtn;
            }

            console.debug(`product-recommendations: init carousel #${idx}`, { slidesPerView, container, inner, options });

            // Initialize Carousel on the outer container (so navigation/pagination can be found)
            const carousel = new window.FoxTheme.Carousel(container, options);
            carousel.init();

            // Some wrappers expose .slider which needs explicit init
            if (carousel.slider && typeof carousel.slider.init === 'function') {
              carousel.slider.init();
            }

            console.info('product-recommendations: carousel initialized', container);
          } catch (err) {
            console.error('product-recommendations: failed to init carousel', err);
          }
        });
      }
    }
  );

  document.addEventListener('recommendations:loaded', () => {
    console.log('Product recommendations loaded event received');
    // FoxTheme.ProductCard.initCards();
    // FoxTheme.ProductCard.initSwatches();
  });
  // document.querySelectorAll('product-recommendations').forEach((section) => {
  //   // Force the constructor to run
  //   void section;
  // });
}
